import React from 'react';
import { motion } from 'framer-motion';
import { painPoints } from '../data/painPoints';
export function PainPoints() {
  return <section aria-label="Problèmes" className="border-y border-grape/10 bg-white/70" data-id="element-105" data-mp="2lmsqcmz6p8ku">
      <div className="mx-auto max-w-4xl px-5 pb-12 pt-10" style={{
      paddingBottom: '8px',
      paddingTop: "11px"
    }} data-id="element-106" data-mp="26xmsp3fzvqf2">
        <h2 className="text-center font-display text-[25px] font-black text-plum sm:text-4xl" data-id="element-107" data-mp="2bvy43ilxu8ze">
          Est-ce que cela vous ressemble ?
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-center text-base leading-relaxed text-plum/70" data-id="element-108" data-mp="21z38b7h1umot">
          Vous travaillez avec des athlètes blessés, mais chaque fois que vous essayez de créer un
          protocole, vous vous perdez entre le choix des exercices, les critères de progression et
          les délais de retour au sport qui ne mènent nulle part.
        </p>
        <p className="mx-auto mt-4 max-w-2xl text-center text-lg font-bold text-grape" data-id="element-109" data-mp="3ibs066ff2if5">
          Ce n'est pas un manque de talent. C'est un manque de système visuel.
        </p>

        <div className="mt-10 grid gap-4 sm:grid-cols-2" data-id="element-110" data-mp="1yyu6xar01xb5">
          {painPoints.map((p, i) => <motion.div key={p.title} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.3,
          delay: i % 2 * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex gap-3 rounded-xl border border-grape/15 bg-cream p-5" style={{
          paddingTop: "10px",
          paddingBottom: "10px"
        }} data-id="element-111" data-mp="1u0sjyeqgddue" data-mpi={i}>
              <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-lilac-soft text-sm" aria-hidden="true" data-id="element-112" data-mp="1b52gso6sabex">
                {p.emoji}
              </span>
              <div data-id="element-113" data-mp="1k5qyptzasvx3">
                <h3 className="text-sm font-bold text-plum" data-id="element-114" data-mp="30he3fq3dkepc">{p.title}</h3>
                <p className="mt-1 text-sm leading-relaxed text-plum/65" data-id="element-115" data-mp="30jquqtv0w1f2">{p.desc}</p>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-12 text-center" data-id="element-116" data-mp="1t5y9amdnch3j">
          <p className="font-display text-2xl font-bold text-plum sm:text-3xl" data-id="element-117" data-mp="1t4vlwofj8wsd">
            ✨ Si vous avez répondu OUI, SIGMA SMART™ a la solution.
          </p>
        </div>
      </div>
    </section>;
}